import { render, staticRenderFns } from "./amendAccount.vue?vue&type=template&id=68a9c67a&scoped=true"
import script from "./amendAccount.vue?vue&type=script&lang=js"
export * from "./amendAccount.vue?vue&type=script&lang=js"
import style0 from "./amendAccount.vue?vue&type=style&index=0&id=68a9c67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a9c67a",
  null
  
)

export default component.exports